const TONES = {
  Vigente: "bg-[rgba(19,182,122,0.12)] text-[#0f8b5f]",
  Liquidado: "bg-[#e8f0ff] text-[#0a47be]",
  "Plazo concluido": "bg-[#fff4dc] text-[#7a5b10]",
  Reestructurado: "bg-[#eaeef5] text-[#3b475c]",
  Refinanciado: "bg-[#eaeef5] text-[#3b475c]",
  "Sin datos suficientes": "bg-[#f1f3f7] text-[#5b667a]",
};
const HINTS = { "Plazo concluido": "El plazo terminó, pero el saldo no es cero según el último Excel" };

export const StatusBadge = ({ status, testId }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-bold ${TONES[status] || TONES["Sin datos suficientes"]}`}
    title={HINTS[status]}
    data-testid={testId}
  >
    {status}
  </span>
);
